import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-case",
  "use": "icon-icon-case-usage",
  "viewBox": "0 0 12.6 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12.6 12\" id=\"icon-icon-case\">\r\n    <defs>\r\n        <style>#icon-icon-case .cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}</style>\r\n    </defs>\r\n    <title>资源 6</title>\r\n    <g id=\"icon-icon-case_图层_2\" data-name=\"图层 2\">\r\n        <g id=\"icon-icon-case_图层_1-2\" data-name=\"图层 1\">\r\n            <polygon class=\"cls-1\" points=\"6.3 0.5 0.5 4 6.3 7.5 12.1 4 6.3 0.5\" />\r\n            <polyline class=\"cls-1\" points=\"3.6 6.2 0.5 8 6.3 11.5 12.1 8 8.8 6.1\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-case.svg
// module id = SJnU
// module chunks = 71